import { MenuItem } from '@mui/material';
import { AxiosError } from 'axios';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorResponse } from '../../../../shared/api/hscan';
import {
  KeycloakErrorResponseDetail,
  Locale,
} from '../../../../shared/api/hscan/account';
import { useChangeLocale } from '../../../../shared/hooks/accountHook';
import dictionaryLanguageBookIcon from '../../assets/icons/icon_dictionary-language-book.svg';
import { ColoredIcon } from '../../common/components/Icon';
import { SelectSlot } from '../../common/components/Slot';
import { SlotRef } from '../../common/components/Slot/types';
import { onChangeLocale } from '../../utils/onChangeLocale';

import { SaveButton, EditButton } from './styledComponent';

export interface EditLocaleProps {
  locale: Locale | null;
  setLocale: (locale: Locale | null) => void;
  edit: boolean;
  onEdit: () => void;
  onEditSuccess?: () => void;
  onEditError?: (
    e: AxiosError<ErrorResponse<KeycloakErrorResponseDetail>>,
  ) => void;
}
export const EditLocale = (props: EditLocaleProps) => {
  const { edit, onEdit, onEditSuccess, onEditError, locale, setLocale } = props;
  const { t } = useTranslation();
  const localeSlotRef = useRef<SlotRef>(null);
  const { mutate: changeLocale } = useChangeLocale({
    onSuccess() {
      onEditSuccess?.();
      const value = localeSlotRef.current?.inputs[0]?.value as Locale;
      if (Object.values(Locale).includes(value)) {
        onChangeLocale(value);
      }
    },
    onError: onEditError,
  });
  return (
    <SelectSlot
      ref={localeSlotRef}
      label={`${t('features.myPage.slots.locale.title')}:`}
      icon={
        <ColoredIcon
          width="24px"
          height="24px"
          imageUrl={dictionaryLanguageBookIcon}
          imageWidth="24px"
          color={'var(--HScan_Light_Blue, #2e5be0)'}
        />
      }
      value={locale ?? ''}
      onChange={value => {
        const locale = value as Locale;
        if (Object.values(Locale).includes(locale)) {
          setLocale(locale);
        }
      }}
      readOnly={!edit}
      endIcon={
        edit ? (
          <SaveButton onClick={() => locale != null && changeLocale(locale)}>
            {t('common.button.save')}
          </SaveButton>
        ) : (
          <EditButton
            onClick={() => {
              onEdit();
              setTimeout(() => localeSlotRef.current?.inputs[0]?.focus(), 0);
            }}
          />
        )
      }
      fullwidth>
      <MenuItem value={''}>{`${t(
        'features.myPage.locale.unselected',
      )}`}</MenuItem>
      <MenuItem value={Locale.en}>{`${t(
        'features.myPage.locale.english',
      )}`}</MenuItem>
      <MenuItem value={Locale.ko}>{`${t(
        'features.myPage.locale.korean',
      )}`}</MenuItem>
      <MenuItem value={Locale.es}>{`${t(
        'features.myPage.locale.spanish',
      )}`}</MenuItem>
      <MenuItem value={Locale.id}>{`${t(
        'features.myPage.locale.indonesian',
      )}`}</MenuItem>
    </SelectSlot>
  );
};
